import { createContext } from "react";

import type useRoleIdentityById from "src/hooks/data/load/useRoleIdentityById";

/**
 * Describes the role identity loader state and its refresh/cache actions.
 */
export interface IRoleIdentityContext extends ReturnType<typeof useRoleIdentityById> {}

/**
 * Shares role identity state with descendants.
 *
 * Postconditions: Without a provider, data and error are undefined and both activity flags are
 * false. Default mutate and refresh calls fulfill with undefined without loading or updating data.
 * Assumptions: Consumers need a matching provider to observe live request state.
 */
export default createContext<IRoleIdentityContext>({
    data: undefined,
    error: undefined,
    loading: false,
    validating: false,
    mutate: async () => undefined,
    refresh: async () => undefined
});
